// Labels every team profile shares, Japanese: section titles, row labels, downloads, contact, PDF sections.
module.exports = {
  personal: {
    title: '基本情報',
    rows: {
      name: '氏名',
      position: '役職',
      birthdate: '生年月日',
      nationality: '国籍',
      maritalStatus: '婚姻状況',
      location: '所在地',
      languages: '語学',
      programmingLanguages: 'プログラミング言語',
      certifications: '資格・認定',
      publications: '論文・著作',
      links: 'ウェブサイト'
    }
  },
  education: {
    title: '学歴'
  },
  skills: {
    title: '専門スキル'
  },
  experience: {
    title: 'プロジェクト・職務経歴',
    techLabel: '使用技術'
  },
  downloads: {
    title: 'プロフィールのダウンロード',
    deLabel: 'ドイツ語版プロフィールをダウンロード',
    deDescription: 'PDF（ドイツ語）',
    enLabel: '英語版CVをダウンロード',
    enDescription: 'PDF（英語）'
  },
  cta: {
    title: 'お問い合わせ',
    button: 'メールで問い合わせる'
  },
  pdf: {
    title: 'プロフィール',
    personalSection: '基本情報',
    educationSection: '学歴',
    experienceSection: 'プロジェクト・職務経歴',
    skillsLabel: 'スキル'
  }
};
